"use client";
import { jsx as a } from "react/jsx-runtime";
import * as s from "@radix-ui/react-tabs";
import { cva as c } from "class-variance-authority";
import { createContext as d, useContext as l } from "react";
import { cn as r } from "./index23.mjs";
import { getAccessibleFocusStyles as u } from "./index24.mjs";
const i = d({}), b = c(
  `data-[state=active]:bg-gray-800 data-[state=active]:text-white
    inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-3 border border-transparent px-4 py-3 text-base border-none whitespace-nowrap
    focus-visible:border-ring focus-visible:ring-ring/50
    ${u()}
    disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer
    [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
  {
    variants: {
      shape: {
        square: "rounded-sm data-[state=active]:rounded-sm",
        rounded: "rounded-md data-[state=active]:rounded-capsule"
      },
      outline: {
        true: "data-[state=active]:border data-[state=active]:border-solid data-[state=active]:border-gray-500",
        false: ""
      }
    },
    defaultVariants: {
      shape: "rounded",
      outline: !1
    }
  }
), x = ({ className: t, shape: e, outline: o, ...n }) => /* @__PURE__ */ a(i.Provider, { value: { shape: e, outline: o }, children: /* @__PURE__ */ a(s.Root, { "data-slot": "tabs", className: r("flex flex-col gap-2", t), ...n }) }), h = ({ className: t, ...e }) => /* @__PURE__ */ a(
  s.List,
  {
    "data-slot": "tabs-list",
    className: r("inline-flex h-13 w-fit items-center justify-center", t),
    ...e
  }
), T = ({ className: t, ...e }) => {
  const { shape: o, outline: n } = l(i);
  return /* @__PURE__ */ a(
    s.Trigger,
    {
      "data-slot": "tabs-trigger",
      className: r(b({ shape: o, outline: n }), t),
      ...e
    }
  );
}, y = ({ className: t, ...e }) => /* @__PURE__ */ a(s.Content, { "data-slot": "tabs-content", className: r("flex-1 outline-none", t), ...e });
export {
  y as TabsContent,
  h as TabsList,
  x as TabsRoot,
  T as TabsTrigger
};
